<template>
    <v-app pb-3>
        <v-content>
            <v-form ref="form">
                <v-container style="max-width: 1200px; padding-top: 100px">
                    <v-layout row wrap pb-5>
                        <v-flex xs12 pb-5>
                            <a href="/dashboard">Личный кабинет</a>
                        </v-flex>
                        <v-flex xs12>
                            <h1>Перевод полисов в оформленные</h1>
                        </v-flex>
                    </v-layout>
                    <v-layout row wrap>
                        <v-flex xs12 md6>
                            <file-upload
                                :validation="fileValidation"
                                @getFile="getFile"
                                @removeFile="removeFile"
                            />
                        </v-flex>
                    </v-layout>
                    <v-layout pt-4 row wrap>
                        <v-flex xs12 sm6>
                            <v-btn @click="validate(submit)"
                                   :loading="loading"
                                   class="next-button button">Загрузить файл
                            </v-btn>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-form>
        </v-content>
    </v-app>
</template>

<script>
export default {
    name: "IssuancePolicies",
    props: [],
    data: () => ({
        file: null,
        fileValidation: true,
        loading: false,
    }),
    created() {

    },
    methods: {
        validateFile() {
            if (!this.file) {
                this.fileValidation = false
                return false
            }
            this.fileValidation = true
            return true
        },

        validate(successFunc) {
            if (this.validateFile()) {
                successFunc();
            } else {
                this.$nextTick(function () {
                    PNotify.error('Пожалуйста, загрузите файл с полисами');
                });
            }
        },
        prepareData() {
            return {
                file: this.file,
            }
        },
        getFile(data) {
            this.fileValidation = true
            this.file = data
        },
        removeFile() {
            this.file = null
        },
        submit() {
            axios.post('/issuance-policies', this.prepareData())
                .then(response => {
                    if (typeof response.data.successLog.length !== 'undefined') {
                        for (let i = 0; i < response.data.successLog.length; i++) {
                            if (typeof response.data.successLog[i].message !== 'undefined') {
                                PNotify.success(response.data.successLog[i].message)
                            } else {
                                PNotify.success('Полис ' + response.data.successLog[i].uuid + ' успешно переведен в оформленные');
                            }
                        }
                    }
                    if (typeof response.data.errorLog.length !== 'undefined') {
                        for (let i = 0; i < response.data.errorLog.length; i++) {
                            PNotify.error('Ошибка полиса ' + response.data.errorLog[i].uuid + ' : ' + response.data.errorLog[i].error);
                        }
                    }
                    console.log(response)
                })
                .catch(error => {
                    console.log(error);
                    PNotify.error(error);
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
</script>

<style scoped>
/deep/ h1 {
    font-size: 48px;
    font-family: 'SFPro';
    line-height: 1.1;
    font-weight: 700;
    color: #000000;
}

/deep/ h2, h3, h4 {
    font-family: 'SFProBold';
}

/deep/ h2 {
    font-size: 28px;
}

/deep/ h3 {
    font-size: 20px;
}

/deep/ h4 {
    font-size: 16px;
}

.centered {
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// resources/js/components/issuance-policies/IssuancePolicies.vue